module.exports = __webpack_public_path__ + "static/media/share_screen_camera.b33de7a4.svg";